import { differenceInDays } from 'date-fns';

import { Absence as AbsenceType } from '../types';
import { Interval } from 'components/types';

import Absence from './Absence';

type Props = {
  absence: AbsenceType;
  date: Date;
  startDate: Date;
  endDate: Date;
  absenceLength: number;
  interval: Interval;
};

export default function AbsenceBlock({
  absence,
  date,
  startDate,
  endDate,
  absenceLength,
  interval
}: Props) {
  const blockLength =
    absenceLength -
    differenceInDays(date, startDate) -
    (endDate > interval.endDate
      ? differenceInDays(endDate, interval.endDate) + 1
      : 0);

  return (
    <Absence
      absence={absence}
      date={date}
      interval={interval}
      className="is-full-block"
      style={{
        width: `calc(${blockLength * 100}% + ${(blockLength - 1) * 5}px)`
      }} // 2px left, 2px right, 1px border
      isFullBlock
    />
  );
}
